import { useState } from 'react'
import { UnitCard, UnitCardPricing } from '@/components/UnitCard'

const FPO_IMAGE = '/wp-content/plugins/ecs-spaces/public/images/spaces-fpo.png'

function Section ({
	title,
	children
}: {
	title: string
	children: React.ReactNode
}) {
	return (
		<div className='spaces:flex spaces:flex-col spaces:gap-16'>
			<h3 className='spaces:text-14 spaces:font-semi spaces:text-content-3 spaces:uppercase spaces:tracking-wide'>
				{title}
			</h3>
			{children}
		</div>
	)
}

const PRICING_MODES: UnitCardPricing[] = [
	'flat',
	'revenue-management',
	'hidden'
]

export function UnitCardSandbox () {
	const [pricingMode, setPricingMode] = useState<UnitCardPricing>('flat')

	return (
		<div className='spaces:flex spaces:flex-col spaces:gap-32'>
			{/* ── Pricing modes ── */}
			<Section title='Pricing Modes'>
				<div className='spaces:flex spaces:gap-8 spaces:mb-8'>
					{PRICING_MODES.map(mode => (
						<button
							key={mode}
							onClick={() => setPricingMode(mode)}
							className={`spaces:text-12 spaces:font-default spaces:rounded-8 spaces:px-12 spaces:py-8 spaces:transition-colors spaces:border spaces:border-canvas-3 ${
								pricingMode === mode
									? 'spaces:bg-brand-subtle spaces:text-brand-on-subtle spaces:border-brand-base'
									: 'spaces:text-content-2 spaces:hover:bg-canvas-2'
							}`}
						>
							{mode}
						</button>
					))}
				</div>
				<div className='spaces:flex spaces:flex-wrap spaces:gap-16 spaces:items-start'>
					<UnitCard
						unitNumber='1201-A'
						floorPlanName='The Alpine'
						floorPlanHref='#'
						imageUrl={FPO_IMAGE}
						beds='2 Bed'
						baths='2 Bath'
						sqft={1145}
						availableDate='October 16'
						priceRange='$2,150–$2,350'
						baseRent='$2,050'
						leaseTerm='12 Mo.'
						tags={[{ label: 'Special', color: 'success', iconLeft: 'Tag' }]}
						pricing={pricingMode}
						hasFees
						hasDisclaimerSymbol
						onPricingClick={() => {}}
					/>
					<UnitCard
						unitNumber='0402-B'
						floorPlanName='The Birch'
						floorPlanHref='#'
						imageUrl={FPO_IMAGE}
						beds='1 Bed'
						baths='1 Bath'
						sqft={756}
						availableDate='November 1'
						priceRange='$1,650–$1,800'
						baseRent='$1,550'
						leaseTerm='12 Mo.'
						tags={[]}
						pricing={pricingMode}
						hasFees={false}
						hasDisclaimerSymbol={false}
						onPricingClick={() => {}}
					/>
				</div>
			</Section>

			{/* ── Compact layout ── */}
			<Section title='Compact Layout (Map Popup)'>
				<div className='spaces:flex spaces:flex-col spaces:gap-16'>
					<UnitCard
						layout='compact'
						unitNumber='1201-A'
						floorPlanName='The Alpine'
						imageUrl={FPO_IMAGE}
						beds='2 Bed'
						baths='2 Bath'
						sqft={1145}
						availableDate='October 16'
						priceRange='$2,150–$2,350'
						baseRent='$2,050'
						leaseTerm='12 Mo.'
						tags={[
							{ label: 'Special', color: 'success', iconLeft: 'Tag' },
							{ label: 'Renovated', color: 'brand' }
						]}
						pricing={pricingMode}
						hasFees
						hasDisclaimerSymbol
						onPricingClick={() => {}}
					/>
					<UnitCard
						layout='compact'
						unitNumber='0402-B'
						floorPlanName='The Birch'
						imageUrl={FPO_IMAGE}
						beds='1 Bed'
						baths='1 Bath'
						sqft={756}
						availableDate='November 1'
						priceRange='$1,650–$1,800'
						baseRent='$1,550'
						leaseTerm='12 Mo.'
						tags={[]}
						pricing={pricingMode}
						hasFees={false}
						hasDisclaimerSymbol={false}
						onPricingClick={() => {}}
					/>
				</div>
			</Section>
		</div>
	)
}
